export interface SpacingProps {
    x1: string;
    x2: string;
    x3: string;
    x4: string;
    x5: string;
    x6: string;
    x7: string;
    x8: string;
    x9: string;
    x10: string;
}

export const spacings: SpacingProps = {
    x1: "4px",
    x2: "8px",
    x3: "12px",
    x4: "16px",
    x5: "20px",
    x6: "24px",
    x7: "28px",
    x8: "32px",
    x9: "36px",
    x10: "40px"
};
